import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAnalyticsCamera } from '@obvious.tech/constellation'

export const AnalyticsCamera = defineEntity('AnalyticsCamera', {
  endpoint: 'analytics/api/AnalyticsCamera',
  schema: SNoop<IAnalyticsCamera>(),
})
